module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/260-united-kingdom-8f32bb7f0af21b75c98cfee21d5f4a3e.svg";